export default __webpack_public_path__ + "static/B0076-f96c6009fddc644b2bcf14200292dda8.png";